export const voucherEndpoints = {
    vouchers: {
        list: {
            api: '/api/voucher/v2',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/voucher/v2/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/voucher/v2/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/voucher/v2/edit',
            method: 'POST',
            parameter: false
        },
        revoke: {
            api: '/api/voucher/v2/revoke',
            method: 'POST',
            parameter: false
        },
        bulkRevoke: {
            api: '/api/voucher/v2/bulk/revoke',
            method: 'POST',
            parameter: false
        },
        bulkRedeem: {
            api: '/api/voucher/v2/bulk/redeem',
            method: 'POST',
            parameter: false
        },
        bulkReturn: {
            api: '/api/voucher/v2/bulk/return',
            method: 'POST',
            parameter: false
        },
        requestAdd: {
            api: '/api/voucher/v2/voucherrequest/updated/add',
            method: 'POST',
            parameter: false
        }
    },
    dictionary: {
        status: {
            api: '/api/voucher/v2/dictionary/voucher-status',
            method: 'GET',
            parameter: false
        },
        voucher: {
            api: '/api/voucher/v2/voucher/dictionary',
            method: 'GET',
            parameter: false
        },
        purchasedVouchers: {
            api: '/api/voucher/v2/voucher/summary/excl/list/delivery',
            method: 'GET',
            parameter: false
        },
        consumptionVouchers: {
            api: '/api/voucher/v2/voucher/summary/excl/list/consumption',
            method: 'GET',
            parameter: false
        },
        promotionTargetType: {
            api: '/api/voucher/v2/promotion/list/target/types',
            method: 'GET',
            parameter: false
        },
        configType: {
            api: '/api/voucher/v2/config/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    buyerVouchers: {
        list: {
            api: 'api/voucher/v2/buyer',
            method: 'GET',
            parameter: true
        }
    },
    examBooking: {
        list: {
            api: '/api/voucher/v2/booked-exam',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/voucher/v2/booked-exam/details',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/voucher/v2/booked-exam/add',
            method: 'POST',
            parameter: false
        },
        reschedule: {
            api: '/api/voucher/v2/booked-exam/reschedule',
            method: 'POST',
            parameter: false
        },
        cancel: {
            api: '/api/voucher/v2/booked-exam/cancel',
            method: 'POST',
            parameter: false
        }
    },
    report: {
        details: {
            api: '/api/voucher/v2/report/details',
            method: 'GET',
            parameter: true
        }
    },
    evaluationVouchers: {
        list: {
            api: '/api/voucher/evaluation/list',
            method: 'GET',
            parameter: true
        },
        requestedList: {
            api: '/api/voucher/evaluation/requestedList',
            method: 'GET',
            parameter: true
        },
        assign: {
            api: '/api/voucher/evaluation/assign',
            method: 'POST',
            parameter: true
        },
        revoke: {
            api: '/api/voucher/evaluation/revoke',
            method: 'POST',
            parameter: true
        },
        extend: {
            api: '/api/voucher/evaluation/extend',
            method: 'POST',
            parameter: true
        },
        approve: {
            api: '/api/voucher/evaluation/approve',
            method: 'POST',
            parameter: false
        },
        reject: {
            api: '/api/voucher/evaluation/reject',
            method: 'POST',
            parameter: false
        },
        available: {
            api: '/api/voucher/evaluation/available',
            method: 'GET',
            parameter: true
        },
        statusList: {
            api: '/api/voucher/evaluation/list/statuses',
            method: 'GET',
            parameter: true
        },
        productVariantList: {
            api: '/api/agora/productvariant/list/evaluation/product-sku',
            method: 'GET',
            parameter: true
        }
    },
    coupons: {
        create: {
            api: '/api/voucher/v2/promotion/add',
            method: 'POST',
            parameter: false
        },
        list: {
            api: '/api/voucher/v2/promotion/list',
            method: 'POST',
            parameter: false
        },
        listPending: {
            api: '/api/voucher/v2/promotion/list-pending',
            method: 'POST',
            parameter: false
        },
        listByStatus: {
            api: '/api/voucher/v2/promotion/list-by-status',
            method: 'GET',
            parameter: true
        },
        listSingle: {
            api: '/api/voucher/v2/promotion/list-single-use',
            method: 'GET',
            parameter: false
        },
        listMultiple: {
            api: '/api/voucher/v2/promotion/list-multiple-use',
            method: 'GET',
            parameter: false
        },
        singlePromotionsList: {
            api: '/api/voucher/v2/promotion/single-use/list',
            method: 'GET',
            parameter: true
        },
        generateCoupons: {
            api: '/api/promotion/single-use/generate-vouchers',
            method: 'POST',
            parameter: false
        },
        revokeCoupon: {
            api: '/api/voucher/v2/revoke',
            method: 'POST',
            parameter: false
        },
        revokeCoupons: {
            api: '/api/voucher/v2/bulk/revoke',
            method: 'POST',
            parameter: false
        },
        assignCoupons: {
            api: '/api/promotion/single-use/assign-vouchers',
            method: 'POST',
            parameter: false
        },
        validateCSV: {
            api: '/api/promotion/single-use/assign-vouchers/csv/validate',
            method: 'POST',
            parameter: false
        },
        approve: {
            api: '/api/voucher/v2/promotion/approve',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/voucher/v2/promotion/details',
            method: 'GET',
            parameter: true
        },
        codesList: {
            api: '/api/voucher/v2/promotion/csv',
            method: 'POST',
            parameter: true
        }
    },
    promotionPricing: {
        config:{
            api: '/api/promo/promopricing/list/config',
            method: 'GET',
            parameter: false
        },
        draftList: {
            api: '/api/promo/prepromopricing/list/draft',
            method: 'GET',
            parameter: false
        },
        releasedList: {
            api: '/api/promo/promopricing/list/released',
            method: 'GET',
            parameter: false
        },
        create: {
            api: '/api/promo/prepromopricing/create',
            method: 'POST',
            parameter: false
        },
        update: {
            api: '/api/promo/promopricing/update',
            method: 'POST',
            parameter: false
        },
        prePromoDetails: {
            api: '/api/promo/prepromopricing/details',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/promo/promopricing/details',
            method: 'GET',
            parameter: true
        },
        checkPromotionExits: {
            api:'/api/promo/promopricing/validate',
            method:'POST',
            parameter:false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/voucher.endpoints.ts